import { ReactElement } from 'react';

import {
   CurrentHealthcareProviderPaymentsConfigurationQuery,
   PaymentsIntegrationConfiguration,
} from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { onlinePaymentsSharedTranslationKeys } from '../translations';

type OnlinePaymentsLoaderRenderProps = {
   onlinePaymentsIntegrationConfiguration: PaymentsIntegrationConfiguration | null;
};

type OnlinePaymentsLoaderProps = {
   readonly children: (renderProps: OnlinePaymentsLoaderRenderProps) => ReactElement;
};

export const OnlinePaymentsLoader = (props: OnlinePaymentsLoaderProps): ReactElement => {
   const {
      data: onlinePaymentsIntegrationConfiguration,
      loading: onlinePaymentsIntegrationConfigurationLoading,
      error: onlinePaymentsIntegrationConfigurationError,
   } = useCqrsFind<PaymentsIntegrationConfiguration>(() => new CurrentHealthcareProviderPaymentsConfigurationQuery());

   if (onlinePaymentsIntegrationConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (onlinePaymentsIntegrationConfigurationError) {
      return (
         <Message
            testId={'failedToFetchIntegrationConfigurationData'}
            label={onlinePaymentsSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      onlinePaymentsIntegrationConfiguration: onlinePaymentsIntegrationConfiguration,
   });
};
